import { z } from "zod";

export const AuditActorSchema = z.object({
  id: z.string(),
  name: z.string().nullable(),
  email: z.string(),
}).nullable().optional();

export const AuditEventSchema = z.object({
  id: z.string(),
  group_id: z.string(),
  actor_user_id: z.string().nullable().optional(),
  event_type: z.string(),
  entity_type: z.string(),
  entity_id: z.string().nullable().optional(),
  summary: z.string(),
  metadata: z.record(z.string(), z.unknown()),
  created_at: z.string(),
  actor: AuditActorSchema,
});

export const AuditEventsResponseSchema = z.object({
  events: z.array(AuditEventSchema),
});

export type AuditEvent = z.infer<typeof AuditEventSchema>;
export type AuditEventsResponse = z.infer<typeof AuditEventsResponseSchema>;
